import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AcTeamDetailsRequestService {
  private readonly _requestedTeamId$ = new BehaviorSubject<string | null>(null);
  public readonly requestedTeamId$: Observable<string | null> = this._requestedTeamId$.asObservable();

  public request(teamId: string): void {
    this._requestedTeamId$.next(teamId);
  }

  public clear(): void {
    if (this._requestedTeamId$.getValue() !== null) {
      this._requestedTeamId$.next(null);
    }
  }
}
